"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.SkillProvision = void 0;
var SkillStatus_1 = require("./SkillStatus");
/**
 * Represents SkillProvision information
 */
var SkillProvision = /** @class */ (function (_super) {
    __extends(SkillProvision, _super);
    function SkillProvision() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._typeName = "SkillProvision";
        /**
         * Id of the tenant
         */
        _this.tenantId = function () {
            _this.push(function (_) { return "tenantId"; });
        };
        /**
         * Skill reference
         */
        _this.reference = function () {
            _this.push(function (_) { return "reference"; });
        };
        /**
         * The name of the skill provision
         */
        _this.qualifier = function () {
            _this.push(function (_) { return "qualifier"; });
        };
        /**
         * Detailed description about the skill provision
         */
        _this.appendent = function () {
            _this.push(function (_) { return "appendent"; });
        };
        /**
         * The list of labels of the skill provision
         */
        _this.labelList = function () {
            _this.push(function (_) { return "labelList"; });
        };
        /**
         * The version used by this skill provision
         */
        _this.version = function () {
            _this.push(function (_) { return "version"; });
        };
        /**
         * The reference to skill
         */
        _this.skillRef = function () {
            _this.push(function (_) { return "skillRef"; });
        };
        /**
         * CPU
         */
        _this.cpu = function () {
            _this.push(function (_) { return "cpu"; });
        };
        /**
         * Memory
         */
        _this.memory = function () {
            _this.push(function (_) { return "memory"; });
        };
        /**
         * Amount of replicas
         */
        _this.replicas = function () {
            _this.push(function (_) { return "replicas"; });
        };
        /**
         * Whether the skill provision should be enabled or not
         */
        _this.enabled = function () {
            _this.push(function (_) { return "enabled"; });
        };
        /**
         * Amount of seconds that the skill requires to be ready
         */
        _this.bootstrapTimeout = function () {
            _this.push(function (_) { return "bootstrapTimeout"; });
        };
        /**
         * Value-Key pairs with information needed for the skill provision
         */
        _this.environment = function () {
            _this.push(function (_) { return "environment"; });
        };
        /**
         * The current status of the skill provision
         */
        _this.status = function (config) { return _this.push(function (registry) {
            var entity = new SkillStatus_1.SkillStatus();
            config(entity);
            return "status { " + entity.render(registry) + " }";
        }); };
        /**
         * The contract associated with this provision
         */
        _this.contract = function () {
            _this.push(function (_) { return "contract"; });
        };
        _this.render = function (registry) { return _this.map(function (e) { return e(registry); }).join(" "); };
        return _this;
    }
    return SkillProvision;
}(Array));
exports.SkillProvision = SkillProvision;
//# sourceMappingURL=SkillProvision.js.map